import {
  Col,
  Form,
  Modal,
  Select,
  Tabs,
  Table,
  Button,
  Row,
  Divider,
  Descriptions,
} from 'antd';
import {
  MinusOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import React, { useContext, useState, useEffect } from 'react';
import { PageContext } from '../../../lib/context';
import { useQuery } from '@apollo/client';
import queries from '../../../utils/gql/queries';
import moment from 'moment';
import CustomerForm from './form';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import AdditionalFeesForm from '../subscriber/addfeesform';
import Notes from '../subscriber/notes';

const ViewCustomerInfo = () => {
  const {
    _onFinish,
    form,
    user,
    meters,
    subPayColumn,
    subBillColumn,
    billsTable,
    paymentsTable,
    subMeterColumn,
    meterReadingTable,
    userMeterReading,
    setShowQR,
    showQR,
    _onFinishScan,
  } = useContext(PageContext);
  const { TabPane } = Tabs;

  let newMeters = [...meters];
  if (user?.meter) {
    newMeters = [...meters, { ...user.meter }];
  }

  const remaining_balance_title = () => {
    const bill = billsTable?.[0]?.total_balance;
    const paid = billsTable?.[0]?.payments_aggregate?.aggregate?.sum?.amount;
    if (bill && paid) {
      const total = bill - paid;
      return (
        <div>
          <div className="text-sm font-semibold">
            REMAINING BALANCE: {total.toLocaleString()}
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="text-sm font-semibold">REMAINING BALANCE: 0</div>
      </div>
    );
  };

  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Profile" key="1">
          <CustomerForm />
        </TabPane>
        <TabPane tab="Meter" key="2">
          <Col span={4}>
            <Button
              className="flex flex-col place-items-center"
              onClick={() => {
                setShowQR(true);
              }}
            >
              Barcode Scanner
            </Button>
            <Modal
              title="Barcode Scanner"
              centered
              visible={showQR}
              closable
              footer={() => <div></div>}
              onCancel={() => setShowQR(false)}
            >
              <div className="self-center justify items center mb-5">
                <BarcodeScannerComponent
                  width={500}
                  height={500}
                  onUpdate={(err, result: any) => _onFinishScan(result?.text)}
                />
              </div>
            </Modal>
          </Col>
          <Divider></Divider>
          <Form form={form} onFinish={_onFinish}>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Meter" name="meter_id">
                  <Select
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {newMeters.map((val: any, index: number) => {
                      return (
                        <Select.Option key={`${index}`} value={val.id}>
                          {val.serial_number}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  SAVE
                </Button>
              </Form.Item>
            </Row>
          </Form>
          {/* <div>
            <Descriptions.Item label="meter_id">
              {`Meter ID: ${userMeterReading?.id}`}
            </Descriptions.Item>
          </div> */}
          <div className="flex flex-row mt-3">
            <div className="w-full mr-3">
              <Table
                title={() => <div className="font-medium">METER READINGS</div>}
                bordered
                dataSource={meterReadingTable}
                columns={subMeterColumn}
              />
            </div>
          </div>
        </TabPane>
        <TabPane tab="Bills" key="3">
          <div className="flex flex-row">
            <div className="w-full mr-3">
              <Table
                dataSource={billsTable}
                columns={subBillColumn}
                title={remaining_balance_title}
                bordered
              />
            </div>
          </div>
        </TabPane>
        <TabPane tab="Payments" key="4">
          <div className="flex flex-row">
            <div className="w-full mr-3">
              <Table dataSource={paymentsTable} columns={subPayColumn} />
            </div>
          </div>
        </TabPane>
        <TabPane tab="Additional Fees" key="5">
          <AdditionalFeesForm />
        </TabPane>
        <TabPane tab="Notes" key="6 ">
          <Notes />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default ViewCustomerInfo;
